import nosTechnologies from "../assets/nos-technologies.png";

import logoAtera from "../assets/logo-atera.png";
import logoAzure from "../assets/logo-azure.png";
import logoMicrosoft from "../assets/logo-microsoft.png";
import logoBitdefender from "../assets/logo-bitdefender-real.png";
import logoDell from "../assets/logo-dell-real.png";
import logoHP from "../assets/logo-hp-real.png";
import logoUbiquiti from "../assets/logo-ubiquiti.png";

const partners = [
  { name: "Atera", img: logoAtera },
  { name: "Microsoft Azure", img: logoAzure, large: true },
  { name: "Microsoft 365", img: logoMicrosoft },
  { name: "Bitdefender", img: logoBitdefender },
  { name: "Dell", img: logoDell },
  { name: "HP", img: logoHP },
  { name: "Unifi", img: logoUbiquiti },
];

export default function Technologies() {
  return (
    <>
      <section className="hero-section section">
        <div className="hero-blob" />
        <div className="container position-relative">
          <div className="row align-items-center gy-5">
            <div className="col-lg-6" data-aos="fade-right">
              <div className="section-img">
                <img
                  src={nosTechnologies}
                  alt="Intelligence artificielle au service de la gestion informatique"
                />
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-left">
              <span className="eyebrow">Nos technologies</span>
              <h1 className="fw-900 mt-3 display-5">
                Des technologies adaptées aux environnements exigeants
              </h1>
              <p className="lead text-secondary mt-3">
                Les cliniques dentaires et les PME d'aujourd'hui dépendent de
                systèmes fiables et sécuritaires pour assurer leurs opérations.
                C'est pourquoi nous misons sur des technologies éprouvées et des
                outils de gestion modernes qui permettent de prévenir les
                problèmes, protéger vos données et assurer la continuité de vos
                activités.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section pt-0">
        <div className="container">
          <span className="eyebrow" data-aos="fade-up">
            Nos partenaires
          </span>
          <h2 className="fw-900 mt-3 mb-4" data-aos="fade-up">
            Les plateformes que nous gérons au quotidien
          </h2>

          <div className="row g-4">
            {partners.map((p, i) => (
              <div
                className="col-6 col-md-4 col-lg-3"
                key={p.name}
                data-aos="fade-up"
                data-aos-delay={(i % 4) * 100}
              >
                <div className="partner-card">
                  <img
                    src={p.img}
                    alt={p.name}
                    className={`partner-logo${p.large ? " partner-logo-lg" : ""}`}
                  />
                  <p className="partner-name">{p.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
